class DiscountManager {
  constructor() {
    this.discountCookieName = "discount_code";
    this.currentDiscount = undefined;
    this.discountCookieToInfoMap = undefined;
    let manager = this;
    document.addEventListener("DOMContentLoaded", function () {

      if (window.freeOffers) {

        manager.freeOffers = window.freeOffers;
        manager.selectableDiscountCodes = manager.freeOffers.map(
          (o) => o["discount_code"]
        );
        manager.discountCookieToInfoMap = window.freeOffers.reduce((map, offer) => {
          const discountCode = offer["discount_code"];
          map.set(discountCode, {
            name: offer.slug,
            displayMessage: offer.name,
            urlPath: discountCode,
            priceDescriptor: offer.box_size_price_description
          });
          return map;
        }, new Map());
      }

    });
  }


  hasAffiliateCode() {
    return sessionStorage.getItem('affiliateCode') || !this.currentDiscountIsSelectable();
  }

  getAffilateDiscount() {
    const possibleAffiliateDiscount = this.getActiveDiscountCookie();
    return this.currentDiscountIsSelectable() ? undefined : possibleAffiliateDiscount;
  }

  getActiveDiscountCookie() {
    return this.getCookie(this.discountCookieName);
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  setDiscountCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
  }

  clearDiscountCookie() {
    this.setDiscountCookie(this.discountCookieName, "", -1);
  }

  isDiscountApplied() {
    return !!this.getCookie(this.discountCookieName);
  }

  setDiscountCode(code) {
    this.currentDiscount = code;
  }

  async applyCurrentDiscount() {
    await this.applyDiscount(this.currentDiscount);
  }

  async applyDiscount(code) {
    if (this.newDiscountIsSelectable()) {
      this.clearDiscountCookie();
      this.setDiscountCookie(this.discountCookieName, code, 7);
      return await this.addFreebieItemsToCart(code);
    }
    // we don't want to clear the discount because it might be set by the affilate link in
    // which case we just move along since the user is not changing their mind
    return;
  }



  async addFreebieItemsToCart(code) {
    const items = [];
    switch (code) {
      case "FREEHALIBUT":
        items.push({ quantity: 2, id: "50515509444882" });
        break;
      case "FREESMOKEDSALMON":
        items.push({ quantity: 2, id: "50230576513298" });
        break;
      case "FREESALMONDIP":
        items.push({ quantity: 2, id: "50230578774290" });
        break;
      case "FREESALMONSPREAD":
        items.push({ quantity: 2, id: "50230578774290" });
        break;
    }
    const addUrl = `${window.Shopify.routes.root}cart/add.js`;

    if (items.length > 0) {
      try {
        const data = await fetch(addUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: items }),
        });
        return data;
      } catch (error) {
        console.error("Error adding freebie items to cart:", error);
      }
    }
  }


  newDiscountIsSelectable() {
        var discountIsSelectable = false;
    discountIsSelectable = !this.currentDiscount || this.selectableDiscountCodes.includes(this.currentDiscount);
    return discountIsSelectable;
  }
  currentDiscountIsSelectable() {
    var discountIsSelectable = false;
    var codeCookieValue = this.getCookie("discount_code");
    discountIsSelectable = !codeCookieValue || this.selectableDiscountCodes.includes(codeCookieValue);
    return discountIsSelectable;
  }
}
window.discountManager = window.discountManager || new DiscountManager();
